/**
 * Shared hub + vendor_documents status display helpers.
 */

export type VendorDocStatusFilter = 'all' | 'pending' | 'approved' | 'rejected'

export function isPendingDocStatus(status: string): boolean {
  return status === 'pending'
    || status === 'pending_review'
    || status === 'changes_requested'
}

export function vendorDocStatusDisplay(
  status: string,
  paidAt?: string | null,
): { label: string; color: string; chipClass: string } {
  if (paidAt) {
    return { label: 'Paid', color: 'var(--green)', chipClass: 'c-grn' }
  }
  if (status === 'approved') {
    return { label: 'Approved', color: 'var(--green)', chipClass: 'c-grn' }
  }
  if (status === 'rejected') {
    return { label: 'Rejected', color: 'var(--red)', chipClass: 'c-red' }
  }
  if (status === 'changes_requested') {
    return { label: 'Changes requested', color: 'var(--amber)', chipClass: 'c-amb' }
  }
  if (isPendingDocStatus(status)) {
    return { label: 'Pending review', color: 'var(--amber)', chipClass: 'c-amb' }
  }
  return { label: status.replace(/_/g, ' '), color: 'var(--ink4)', chipClass: 'c-blue' }
}

export const VENDOR_DOC_FILTER_LABELS: Record<VendorDocStatusFilter, string> = {
  all:      'All',
  pending:  'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
}

export function matchesDocFilter(status: string, filter: VendorDocStatusFilter): boolean {
  if (filter === 'all') return true
  if (filter === 'pending') return isPendingDocStatus(status)
  return status === filter
}
